import { ResponsiveLine } from '@nivo/line'
import { useChartData } from '../hooks/useChartData'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const LineChart = () => {
  const theme = useStatsTheme((s) => s.theme)
  const { data } = useChartData()

  return (
    <ResponsiveLine
      data={data}
      colors={(d) => d.color}
      curve="linear"
      margin={{ top: 5, left: 10, right: 10, bottom: 5 }}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={null}
      enableGridX={true}
      enableGridY={true}
      gridYValues={[1, 2, 3, 4, 5]}
      lineWidth={3}
      pointColor={theme.colors.section.bg}
      pointBorderWidth={3}
      pointBorderColor={{ from: 'serieColor', modifiers: [] }}
      yScale={{
        type: 'linear',
        min: 0,
        max: 5,
      }}
      legends={[]}
      animate={false}
      theme={{
        grid: {
          line: {
            stroke: theme.colors.section.chart.lines,
            strokeDasharray: '2 4',
          },
        },
      }}
    />
  )
}
